import { ReactElement } from 'react'
import classNames from 'classnames'
import { HiX } from 'react-icons/hi'

export enum progressBarStateEnum {
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}

export function ProgressBar({
  title,
  subtitle,
  icon,
  uploadPercentage,
  state = progressBarStateEnum.IDLE,
  className,
  handleRemoveButtonClick,
  selected,
  disabled,
  onClick,
}: {
  title: string
  subtitle: string
  icon: ReactElement
  uploadPercentage: number
  className?: string
  state: progressBarStateEnum
  handleRemoveButtonClick?: () => void
  selected?: boolean
  disabled?: boolean
  onClick?: () => void | null
}) {
  return (
    <div
      className={classNames(
        'relative h-20 bg-core-grey-20 rounded-xl m-1 font-mori',
        selected && {
          'outline outline-2 outline-acai-80':
            state === progressBarStateEnum.LOADING ||
            state === progressBarStateEnum.IDLE,
          'outline outline-2 outline-core-tree-90':
            state === progressBarStateEnum.SUCCESS,
          'outline outline-2 outline-core-error':
            state === progressBarStateEnum.ERROR,
        },
        { 'cursor-pointer': onClick },
        { 'opacity-40': disabled },
        className
      )}
      onClick={() => {
        if (!disabled && typeof onClick === 'function') {
          onClick()
        }
      }}
    >
      <div
        className={classNames('h-20 absolute top-0 left-0 rounded-xl', {
          'bg-core-purple-10':
            state === progressBarStateEnum.LOADING ||
            state === progressBarStateEnum.IDLE,
          'bg-core-tree-10': state === progressBarStateEnum.SUCCESS,
          'bg-core-light-error': state === progressBarStateEnum.ERROR,
        })}
        style={{
          width: `${uploadPercentage}%`,
          transition: 'width 1s ease-in-out',
        }}
      ></div>
      <div className="absolute flex items-center justify-between w-full h-20 px-5">
        {icon}
        <div className="flex-1 w-[10%] py-4 pl-5">
          <div
            className={classNames('font-bold text-lg truncate', {
              'text-acai':
                state === progressBarStateEnum.LOADING ||
                state === progressBarStateEnum.IDLE,
              'text-core-tree-100': state === progressBarStateEnum.SUCCESS,
              'text-core-error': state === progressBarStateEnum.ERROR,
            })}
          >
            {title}
          </div>
          <div
            className={classNames('text-base ', {
              'text-acai-40':
                state === progressBarStateEnum.LOADING ||
                state === progressBarStateEnum.IDLE,
              'text-core-tree-80': state === progressBarStateEnum.SUCCESS,
              'text-core-error': state === progressBarStateEnum.ERROR,
            })}
          >
            {subtitle}
          </div>
        </div>
        {handleRemoveButtonClick && (
          <button
            onClick={handleRemoveButtonClick}
            tabIndex={0}
            className="focus-visible:ring-2 focus-visible:ring-core-rose hover:cursor-pointer"
          >
            <HiX
              className={classNames('w-6 h-6 ', {
                'text-acai':
                  state === progressBarStateEnum.LOADING ||
                  state === progressBarStateEnum.IDLE,
                'text-core-tree-100': state === progressBarStateEnum.SUCCESS,
                'text-core-error': state === progressBarStateEnum.ERROR,
              })}
              aria-hidden="true"
            />
          </button>
        )}
      </div>
    </div>
  )
}
